"use strict";

exports.__esModule = true;
exports.HandleQueryError = void 0;
var _react = _interopRequireDefault(require("react"));
var _Translator = require("../../Core/Translator");
var _UhOh = require("../../Core/UhOh");
var _ErrorText = require("../common/AggregateMetricCharts/ErrorText");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HandleQueryError = exports.HandleQueryError = function HandleQueryError(_ref) {
  var error = _ref.error,
    width = _ref.width,
    height = _ref.height;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  if (error && error.response && error.response.message) {
    return error.response.message === "Failed to fetch data" ? /*#__PURE__*/_react["default"].createElement(_ErrorText.ErrorText, {
      width: width,
      height: height
    }, translate("AggregateMeasures.error.failedToLoadNotSupportedWidget", "Selected Timeline/Measure is not supported in this widget")) : /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
      error: error,
      title: error.response.message
    });
  } else {
    return /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
      error: error,
      title: translate("AggregateMeasures.error.failedToLoad", "Failed to load Aggregated Measures")
    });
  }
};